<template>
  <div
    class="person-with-status flex"
    data-qa="person-with-status">
    <template v-if="with_photo">
      <AvatarsBlock
        v-if="users"
        :people="avatars"/>
      <UserIcon
        v-else
        :name="user.fullName || user.fio || (user.user ? user.user.firstName : '')"
        size="32"
        :src="user.avatar"/>
    </template>
    <div class="mt-1 ml-2 flex flex-wrap flex-direction-column">
      <div>
        <StatusChip
          class="mb-1"
          :name="statusName"
          :status="status"/>
      </div>
      <div>
        <StatusChip
          v-if="show_additional && user.isAdditional"
          class="ml-1 mb-1"
          :name="$t('Common.Additional')"
          status="additionalAgreement"/>
      </div>
      <template v-if="users">
        <template v-for="(item, n) in computedUsers.slice(0, 3)">
          <PersonTooltip
            v-if="!without_tooltip"
            :key="n"
            class="ml-2"
            :department="item.department"
            :name="item.userName"/>
          <span
            v-else
            :key="n"
            class="text-start">
            {{ item.userName }}
          </span>
        </template>
        <div
          v-if="users.length > 3"
          class="text-start">
          ...
        </div>
      </template>
      <template v-else-if="user">
        <PersonTooltip
          v-if="!without_tooltip"
          class="ml-2"
          :department="user.department"
          :name="userName"/>
        <span
          v-else
          class="text-start">
          {{ userName }}
        </span>
      </template>
    </div>
    <sButton
      v-if="showHistory"
      class="person-with-status__info"
      icon="info"
      small
      type="text"
      @click="sendInfoEvent"/>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'
import AvatarsBlock from 'components/common/elements/AvatarsBlock.vue'

import { datePickerMixin } from 'mixins'

/**
 * Блок согласовантов
 */
export default {
  name: 'personWithStatus',
  mixins: [datePickerMixin],
  data() {
    return {
      avatar: ''
    }
  },
  props: {
    statusName: String,
    status: String,
    with_photo: Boolean,
    without_tooltip: Boolean,
    show_additional: Boolean,
    user: Object,
    users: Array,
    avatars: Array,
    tenderId: {
      type: [String, Number]
    },
    /**
     * Отключаем внутреннюю сортировку. Для нового процесса согласования сортируем на беке
     * По факту, костыль
     */
    withoutOrder: {
      type: Boolean
    }
  },
  computed: {
    cur_user() {
      return this.$store.getters['GET_USER']
    },
    userId() {
      return this.cur_user?.purchasingSettings?.userId
    },
    contactId() {
      return this.cur_user?.tenderSettings?.contactId
    },
    userName() {
      return this.getName(this.user)
    },
    computedUsers() {
      if (!this.users || !this.users?.length) {
        return []
      }
      const getOrder = (item) => {
        let result = item.isAdditional ? 10 : 0

        switch (item.status) {
        case 'WAITING':
          result += 1
          break
        case 'QUEUED':
          result += 2
          break
        case 'DECLINE':
          result += 3
          break
        case 'CANCELED':
        case 'SUCCESS':
          result += 4
          break
        default:
          break
        }
        return result
      }
      const sortStage = (a, b) => {
        return a.order - b.order || new Intl.Collator('ua').compare((a.fullName || a.fio)?.toLowerCase(), (b.fullName || b.fio)?.toLowerCase())
      }

      return this.users.map(user => {
        return {
          ...user,
          userName: this.getName(user),
          order: getOrder(user)
        }
      })
        .sort((a, b) => this.withoutOrder ? null : sortStage(a, b)
        )
    },
    showHistory() {
      if (!this.user) {
        return false
      }
      const correctSuccessForm = this.status === 'SUCCESS'
        ? this.user?.agreeFormCode && this.user?.agreeFormCode !== 'AGREE_FORM'
        : false
      const correctDisagreeForm = this.status === 'CANCELED' || this.status === 'DECLINE'
        ? this.user?.disagreeFormCode && this.user?.disagreeFormCode !== 'DISAGREE_FORM'
        : false
      return correctSuccessForm || correctDisagreeForm
    },
  },
  methods: {
    sendInfoEvent() {
      const isAgree = this.status === 'SUCCESS'
      const version = isAgree ? this.user?.agreeFormVersion : this.user?.disagreeFormVersion

      const modelEvent = {
        version,
        formCode: isAgree ? this.user.agreeFormCode : this.user.disagreeFormCode,
      }
      const tenderId = (this.tenderId || this.$route.params.id).toString()
      if (version) {
        modelEvent.contactId = +this.user.contactId
        modelEvent.tenderId = +tenderId
      } else {
        modelEvent.params = [
          {key: 'tenderId',
            value: tenderId
          },
          {
            key: 'contactId' ,
            value: this.user.contactId.toString()
          }
        ]
      }
      this.$emit('click-info', modelEvent)
    },
    getName(user) {
      if (!this.cur_user || !user) { return '' }
      let id = (user.user?.userId && user.user?.userId == this.userId)
        || (user.id && user.id == this.userId)
        || (user.contactId && user.contactId == this.contactId )
        || (user.userId && user.userId == this.userId)
        || user.isMy
      return id ? this.$t('Common.You') : user.fullName || user.userId && user?.userId?.trim() || user.fullName || user.fio || user.user?.fullName || this.$t('Common.NoData')
    }
  },
  components: {
    UserIcon,
    StatusChip,
    AvatarsBlock,
    PersonTooltip
  }
}
</script>
<style lang="scss" scoped>
.v-list-item {
  height: 20px;
  max-height: 20px;
  min-height: 20px;
}
.person-with-status__info {
  min-height: 24px;
  height: 24px;
  width: 24px;
  min-width: 24px;
  margin-left: 3px;
}
</style>
